import { useState } from "react";
import { useFavorites } from "@/hooks/useFavorites";

interface DetailActionsProps {
  id: string;
  title: string;
}

export default function DetailActions({ id, title }: DetailActionsProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const [toast, setToast] = useState("");
  const favorited = isFavorite(id);

  const showToast = (message: string) => {
    setToast(message);
    window.setTimeout(() => setToast(""), 2400);
  };

  const handleFavorite = () => {
    const nowFavorited = toggleFavorite(id);
    showToast(nowFavorited ? "已加入收藏（本地演示，可再次点击取消）" : "已取消收藏");
  };

  const handleShare = async () => {
    const url = window.location.href;
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(url);
        showToast("链接已复制，可分享给好友（本地演示）");
      } else {
        showToast(`分享链接：${url}`);
      }
    } catch {
      showToast("复制失败，请手动复制浏览器地址");
    }
  };

  return (
    <div className="relative flex flex-wrap items-center gap-3">
      <button
        type="button"
        onClick={handleFavorite}
        className={`inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md px-4 py-2.5 text-sm font-medium transition-colors ${
          favorited
            ? "bg-accent-500 text-background-50 hover:bg-accent-600"
            : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-400 hover:text-primary-700"
        }`}
      >
        <i className={favorited ? "ri-heart-3-fill" : "ri-heart-3-line"}></i>
        {favorited ? "已收藏" : "收藏"}
      </button>
      <button
        type="button"
        onClick={handleShare}
        className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-secondary-400 hover:text-secondary-700"
      >
        <i className="ri-share-forward-line"></i>
        分享
      </button>
      <p className="text-xs text-foreground-400">收藏与分享为前端演示，不接入后台服务</p>

      {toast && (
        <div className="fixed bottom-8 left-1/2 z-50 -translate-x-1/2 animate-fade-in rounded-md bg-foreground-900 px-4 py-2.5 text-sm text-background-50">
          {toast}
        </div>
      )}
      <span className="sr-only">{title}</span>
    </div>
  );
}